module.exports = __webpack_public_path__ + "static/media/crafty.f7cadf0d.webp";